import { api } from "@/api";
import { FullMatchDto } from "./getFullMatches";

export const manualCancelMatch = async (matchId: string): Promise<FullMatchDto> => {
  const res = await api.client.post(`/matches/${matchId}/manual-cancel`);
  return res.data;
};
